module.exports = __webpack_public_path__ + "../assets/img/8252937eb5c9d5a97a5d55799b0455e8.svg";